<template>
  <q-page padding>
    <div class="row col-12 justify-between">
      <div>
        <p class="text-h6 text-weight-bold text-brand-1 texto-titulo">
          Gestão de Catálogo:
          {{ dados.vendors ? dados.vendors[0].name : dados.code }}
        </p>
      </div>
      <div>
        <router-link :to="{ name: 'catalogo-listareditarcriar' }">
          <div
            style="cursor: pointer"
            class="row items-center text-weight-bold text-brand-5 q-mr-md container-link-voltar"
          >
            <q-icon class="q-mr-sm icon-voltar" name="west" color="brand-5" />
            <span class="texto-titulo">Voltar</span>
          </div>
        </router-link>
      </div>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-lg q-ml-md container-inputs"
    >
      <div>
        <q-btn
          label="Criar Produto"
          no-caps
          color="positive"
          class="btn"
          icon="add"
          @click="criarNovoProduto = !criarNovoProduto"
        />
      </div>
      <div
        v-if="criarNovoProduto"
        class="row col-12 q-mt-lg q-ml-md q-gutter-sm container-input-criar"
      >
        <div class="col-md-2 col-xs-4 col-sm-4">
          <div class="q-ml-sm texto-titulo-input">Código</div>
          <q-input v-model="produto.codigo" class="input" dense outlined />
        </div>
        <div class="col-md-2 col-xs-4 col-sm-4">
          <div class="q-ml-sm texto-titulo-input">Descrição</div>
          <q-input v-model="produto.descricao" class="input" dense outlined />
        </div>
        <div>
          <p></p>
          <q-btn
            label="Criar"
            no-caps
            dense
            class="q-mt-sm btn"
            color="positive"
            icon="check_circle_outline"
            @click="criarProduto()"
          />
        </div>
      </div>
    </div>
    <TabelaTodosProdutos
      :unidadeId="unidadeId"
      :tipoCatalogo="tipo"
      :atualizar="atualizarTodosProdutos"
      @atualizarCatalogo="escolherCatalogoTipo"
    />

    <ProdutosCatalogo
      v-if="listaProdutos"
      :produtosCatalogo="listaProdutos"
      @buscar="buscar"
      :tipoCatalogo="tipo"
      :catalogoId="$route.params.unidadeId"
      :vendorId="
        dados.vendors && dados.vendors.length ? dados.vendors[0].id : null
      "
      @paginarTabela="paginarTabela"
      @atualizarTabela="listarProdutosCatalogo"
    />
  </q-page>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

import TabelaTodosProdutos from "../components/TabelaTodosProdutos.vue";
import ProdutosCatalogo from "../components/ProdutosCatalogo.vue";
export default {
  components: { TabelaTodosProdutos, ProdutosCatalogo },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const quasar = useQuasar();

    const unidadeId = route.params.unidadeId;
    const listaProdutos = ref([]);
    const dados = ref([]);
    const tipo = ref("");
    const filtros = ref({ busca: "" });
    let criarNovoProduto = ref(false);
    let atualizarTodosProdutos = ref(0);
    const produto = ref({
      codigo: "",
      descricao: "",
    });

    const listarProdutosCatalogo = async (page = 0, rowsNumber = 6) => {
      const response = await store.dispatch("catalogo/listarProdutosCatalogo", {
        per_page: rowsNumber,
        page: page,
        vendor_id: unidadeId,
        epi: tipo.value,
        search: filtros.value.busca,
      });

      dados.value = response.data.model;
      listaProdutos.value = response.data.model.products;
    };

    const escolherCatalogoTipo = async () => {
      if (route.name == "catalogo-gestaocatalogo-epis") {
        tipo.value = "sim";
        listarProdutosCatalogo();
      } else if (route.name == "catalogo-gestaocatalogo-nao-epis") {
        tipo.value = "nao";
        listarProdutosCatalogo();
      } else {
        tipo.value = "";
        listarProdutosCatalogo();
      }
    };

    const buscar = (busca) => {
      filtros.value.busca = busca;
      listarProdutosCatalogo();
    };

    const criarProduto = async () => {
      try {
        await store.dispatch("catalogo/criarProduto", {
          name: produto.value.descricao,
          code: produto.value.codigo,
          description: produto.value.descricao,
        });
        setTimeout(() => {
          atualizarTodosProdutos.value++;
        }, 500);

        quasar.notify({
          message: "Produto criado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        produto.value = { codigo: "", descricao: "" };
        criarNovoProduto.value = false;
        listarProdutosCatalogo();
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao criar produto",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const voltar = async () => {
      router.push({ name: "catalogo-listareditarcriar" });
    };

    const paginarTabela = async (page, rowsNumber) => {
      listarProdutosCatalogo(page, rowsNumber);
    };

    onMounted(escolherCatalogoTipo);

    return {
      listarProdutosCatalogo,
      listaProdutos,
      escolherCatalogoTipo,
      tipo,
      dados,
      unidadeId,
      buscar,
      filtros,
      paginarTabela,
      voltar,
      criarNovoProduto,
      produto,
      criarProduto,
      atualizarTodosProdutos,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.cursor {
  cursor: pointer;
  margin-top: 3px;
}
.texto-titulo {
  font-size: 20px;
}
.container-link-voltar {
  margin-right: 10px;
}
.icon-voltar {
  font-size: 25px;
}
@media (max-width: 600px) {
  .cursor {
    cursor: pointer;
    margin-top: 12px;
  }
  .texto-titulo {
    font-size: 16px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }
  .btn {
    font-size: 12px;
  }
  .container-inputs {
    margin: 15px 0px 0px 0px;
  }
  .container-input-criar {
    margin: 7px 0px 0px 0px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
  }
  .input {
    font-size: 12px;
  }
}
</style>
